<template>
  <nav id="top-navigation" class="z-10 relative" role="navigation">
    <div class="shadow top_nav grid">
      <div>
        <button
          v-if="!isRoot"
          @click="navigateTo('/news')"
          class="vb_logo pl-2"
          aria-label="home"
        >
          <img src="@/assets/imgs/seal.jpg" width="42" aria-hidden="true" />
        </button>
      </div>

      <span class="text-2xl">
        <p class="top_nav_hdr font-semibold text-center text-dark-blue-500">
          {{ pageTitle }}
        </p>
      </span>
    </div>
  </nav>
</template>

<script>
import router from "../router";
import store from "../store";
import { mapGetters } from "vuex";

export default {
  props: ["pageTitle"],
  computed: {
    ...mapGetters("navigation", ["navigationItems"]),
  },
  data() {
    return {
      isRoot: false,
    };
  },

  /**
   * Watch for the change in the verified boolean
   */
  watch: {
    /**
     * Watch for changes to the route
     */
    $route: function(to, from) {
      this.isRoot = this.$router.currentRoute.name == "News";
    },
  },

  methods: {
    /**
     * Navigiate to the provided path
     * @param  {string} path [path to use to navigate to]
     */
    navigateTo(path) {
      if (this.$route.path != path) {
        router.push({ path: path });
      }
    },
  },
  // ------------------
  // VueJS Lifecycle Hooks
  // ------------------
  async mounted() {
    try {
      await store.dispatch("navigation/loadNavigation");
    } catch (e) {
      store.dispatch("navigation/loadNavigation"); // try one more time
    }
  },
};
</script>
